module.exports = __webpack_public_path__ + "static/img/43-3.84fc50e.png";